import React from 'react';

import { T } from 'react-translator-component';

import { MapSubtitlesWrapper, SubtitlesGrid, Subtitle } from './styles';

import darkBluePoint from '../../../assets/darkBluePoint.png';
import grayPoint from '../../../assets/grayPoint.png';
import greenPoint from '../../../assets/greenPoint.png';
import orangePoint from '../../../assets/orangePoint.png';

const MapSubtitles = () => {
  return (
    <MapSubtitlesWrapper>
      <p>{T('Subtitles')}</p>
      <SubtitlesGrid>
        <Subtitle>
          <img src={greenPoint} alt={T('Available')} width="20" height="24" />
          {T('Available')}
        </Subtitle>
        <Subtitle>
          <img src={orangePoint} alt={T('Busy')} width="20" height="24" />
          {T('Busy')}
        </Subtitle>
        <Subtitle>
          <img
            src={darkBluePoint}
            alt={T('Maintenance')}
            width="20"
            height="24"
          />
          {T('Maintenance')}
        </Subtitle>
        <Subtitle>
          <img src={grayPoint} alt={T('Unavailable')} width="20" height="24" />
          {T('Unavailable')}
        </Subtitle>
      </SubtitlesGrid>
    </MapSubtitlesWrapper>
  );
};

export default MapSubtitles;
